import { color } from "style/constants";

export default {
  colorPrimary: {
    backgroundColor: color.DARKBLUE,
    color: color.WHITE
  },
  colorSecondary: {
    backgroundColor: color.FUSCHIA,
    color: color.WHITE
  }
};
